import { useMemo } from "react";
import HttpService from "./httpService";
import nvCookieHelpers from "./cookieService";
import { useTranslation } from "react-i18next";
const useHttpService = () => {
    const enviromentURL = () => {
        let envURL = "https://api.store.nvidia.com";
        let host = window.location.hostname;
        if (host.split(".")[0] !== "store" && host !== "marketplace.nvidia.com") {
            envURL = `https://${host.split(".")[0].split("-")[0]}-api.store.nvidia.com`;
        }
        if (host.indexOf("localhost") > -1) {
            envURL = "https://dev-api.store.nvidia.com";
        }

        return envURL;
    };
    const API_URL = useMemo(() => enviromentURL(), []);
    const httpService = useMemo(() => new HttpService(API_URL), [API_URL]);
    return httpService;
};
export const useAuth = () => {
    const httpService = useHttpService();
    const sessionexpiredID = nvCookieHelpers.getCookie('session_expired');
    const { t } = useTranslation();



    const RegisterUser = async (
        partner: boolean,
        formData: any,
        formBillingData: any,
        formShippingData: any,
        shippingOptions: any,
        locale: string | null | undefined,
        handleSuccess: (result: any) => void,
        handleError: (e: any) => void
    ) => {
        let headerObj = { "content-type": "application/json", "X-nvlogin": "true" };
        let signUpBody = {
            "firstName": formBillingData.firstNameBilling,
            "lastName": formBillingData.lastNameBilling,
            "locale": locale?.replace(/-/g, "_").toUpperCase(),
            "username": formBillingData.emailBilling,
            "email": formBillingData.emailBilling,
            "password": formBillingData.passwordBilling
        };
        const billaddr = {
            "firstName": formBillingData.firstNameBilling,
            "lastName": formBillingData.lastNameBilling,
            "line1": formData.iBillingFormAddress.address,
            "city": formData.iBillingFormAddress.cityValue,
            "countrySubdivision": formData.iBillingFormAddress.stateValue,
            "postalCode": formData.iBillingFormAddress.pincode,
            "country": formData.iBillingFormAddress.countryValue,
            "countryName": formData.iBillingFormAddress.countryName,
            "emailAddress": formBillingData.emailBilling,
            "phoneNumber": formBillingData.contactBilling
        }
        const shipaddr = {
            "firstName": formData.firstNameShiping,
            "lastName": formData.lastNameShiping,
            "line1": formShippingData?.address,
            "city": formShippingData?.cityValue,
            "countrySubdivision": formShippingData?.stateValue,
            "postalCode": formShippingData?.pincode,
            "country": formShippingData?.countryValue,
            "countryName": formShippingData?.countryName,
            "emailAddress": formBillingData.emailBilling,
            "phoneNumber": formData.contactShiping
        }
        const shipopt = shippingOptions?.shippingOption?.toString();
        let cartResult = {
            billingAddress: billaddr,
            shippingAddress: shipaddr,
            shippingOptionId: shipopt,
            customAttributes: {
                attribute: [
                    {
                        name: "shipToCategory",
                        value: shippingOptions.shippingTo
                    }
                ]
            }
        }
        try {
            if (sessionexpiredID !== undefined || !JSON.parse(sessionexpiredID)) {
                const result = await httpService.post("/ucc-software/v2/auth/register", signUpBody, headerObj);
                if (result) {
                    console.log("Form submitted:", result);
                    handleSuccess(cartResult);
                    return result;
                }
            } else {
                if (sessionexpiredID === undefined || JSON.parse(sessionexpiredID)) {
                    handleError(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
                }
                throw new Error('User Session has been expired');
            }
        } catch (error) {
            console.log(error);
            if (typeof error === 'string') {
                console.error("API Failure:", error);
            } else {
                console.error("API Failure: An unexpected error occurred.");
            }
            handleError(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
            handleError(error);
            return error;
        }
    };

    const InvalidateCheckoutSession = async (handleSuccess: (result: any) => void, handleError: () => void) => {
        try {
            const headerObj = { "X-nvlogin": "true" };
            const result = await httpService.post("/ucc-software/v2/auth/logout", '', headerObj);
            if (result) {
                handleSuccess(result);
            }
        } catch (error) {
            console.error(error);
            handleError();
        }
    }

    const LogoutUser = async (handleLogoutSuccess: (result: any) => void, handleLogoutError: () => void) => {
        try {
            const headerObj = { "X-nvlogin": "true" };
            const result = await httpService.post("/ucc-software/v2/auth/logout?sso=true", '', headerObj);
            if (result) {
                handleLogoutSuccess(result);
            }
        } catch (error) {
            console.error(error);
            handleLogoutError();
        }
    }

    const HandleSSOLogin = async (handleSubmit: (userType: string) => void,
        handleError: (e: string) => void) => {
        try {
            const headerObj = { "X-nvlogin": "true" };
            const result = await httpService.post("/ucc-software/v2/auth/sso-login", '', headerObj);
            if (result) {
                handleSubmit('loggedIn')
            } else {
                console.error("Login Failed");
            }
        } catch (error) {
            handleError(t('YOUR_SHOPPING_CART_IS_CURRENTLY_EMPTY'));
            console.error("Login Error:", error);
        }

    }

    return { RegisterUser, LogoutUser, InvalidateCheckoutSession, HandleSSOLogin };
}